<!-- *ngIf="showTopFooter"-->
<footer class="text-lg-start">
  <div  class="top-footer"  style="background-color: rgb(72, 75, 72);">
    <!-- Grid container -->
    <div class=" container">
      <!--Grid row-->
      <div class="row">
        <!--Grid column-->
        <div class="col-lg-3 col-md-6 mb-4 mb-lg-0 ">
          <h5 class="text-uppercase text-white">UNIDADES</h5>
          <ul class="list-unstyled mb-0">
            <li>
              <a href="https://registro.espe.edu.ec" class="">Registro</a>
            </li>
            <li>
              <a href="https://biblioteca.espe.edu.ec" class="">Biblioteca</a>
            </li>
            <li>
              <a href="https://ube.espe.edu.ec" class="">Bienestar Estudiantil</a>
            </li>
            <li>
              <a href="https://ugt.espe.edu.ec" class="">Gestión de Tecnologías</a>
            </li>
            <li>
              <a href="https://idiomas.espe.edu.ec" class="">Instituto de Idiomas</a>
            </li>
            <li>
              <a href="https://investigacion.espe.edu.ec" class="">Investigación</a>
            </li>
            <li>
              <a href="https://sgc.espe.edu.ec" class="">Planificación y Desarrollo Institucional</a>
            </li>
            <li>
              <a href="https://urci.espe.edu.ec" class="">Relaciones de Cooperación Interinstitucional</a>
            </li>
            <li>
              <a href="https://ugvc.espe.edu.ec" class="">Vinculación con la Sociedad</a>
            </li>
            <li>
              <a href="https://uth.espe.edu.ec" class="">Talento Humano</a>
            </li>
          </ul>
        </div>
        <!--Grid column-->
        <!--Grid column-->
        <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
          <h5 class="text-uppercase text-white">CENTROS</h5>

          <ul class="list-unstyled mb-0">
            <li>
              <a href="https://www.espe-innovativa.edu.ec/cencinat/" class="">Centro CENCINAT</a>
            </li>
            <li>
              <a href="https://cicte.espe.edu.ec" class="">Centro CICTE</a>
            </li>
            <li>
              <a href="https://cec.espe.edu.ec" class="">Centro de Educación Continua</a>
            </li>
            <li>
              <a href="https://cespe.espe.edu.ec" class="">Centro de Estudios Estratégicos</a>
            </li>
            <li>
              <a href="https://ugp.espe.edu.ec" class="">Centro Posgrados</a>
            </li>
          </ul>
          <p><br></p>
          <h5 class="text-uppercase text-white">SEDES</h5>

          <ul class="list-unstyled mb-0">
            <li>
              <a href="https://espe-el.espe.edu.ec" class="">Latacunga</a>
            </li>
            <li>
              <a href="https://santodomingo.espe.edu.ec/" class="">Santo Domingo</a>
            </li>
          </ul>
        </div>
        <!--Grid column-->
        <!--Grid column-->
        <div class="col-lg-3 col-md-12 mb-4 mb-md-0">
          <h5 class="text-uppercase text-white">Departamentos MATRIZ</h5>
          <ul class="list-unstyled mb-0">
            <li>
              <a href="https://decc.espe.edu.ec" class="">Ciencias de la Computación</a>
            </li>
            <li>
              <a href="https://dectc.espe.edu.ec" class="">Ciencias de la Tierra y de la Construcción</a>
            </li>
            <li>
              <a href="https://decv.espe.edu.ec" class="">Ciencias de la Vida y de la Agricultura</a>
            </li>
            <li>
              <a href="https://deceac.espe.edu.ec" class="">Ciencias Económicas Adminitrativas y de Comercio</a>
            </li>
            <li>
              <a href="https://dece.espe.edu.ec" class="">Ciencias Ciencias Exactas </a>
            </li>
            <li>
              <a href="https://dechs.espe.edu.ec" class="">Ciencias Humanas y Sociales</a>
            </li>
            <li>
              <a href="https://deee.espe.edu.ec" class="">Eléctrica, Electrónica y Telecomunicaciones</a>
            </li>
            <li>
              <a href="https://decem.espe.edu.ec" class="">Ciencias de la Energía y Mecánica</a>
            </li>
            <li>
              <a href="https://desd.espe.edu.ec" class="">Seguridad y Defensa</a>
            </li>
          </ul>
        </div>
        <!--Grid column-->
        <!--Grid column-->
        <div class="col-lg-3 col-md-12 mb-4 mb-md-0">
          <h5 class="text-uppercase text-white">DEPARTAMENTOS LATACUNGA</h5>
          <ul class="list-unstyled mb-0">
            <li>
              <a href="https://dece-el.espe.edu.ec" class="">Ciencias Exactas</a>
            </li>
            <li>
              <a href="https://decem-el.espe.edu.ec" class="">Ciencias de Energía y Mecánica</a>
            </li>
            <li>
              <a href="https://deceac-el.espe.edu.ec" class="">Ciencias Económicas, Administrativas y del Comercio</a>
            </li>
            <li>
              <a href="https://deee-el.espe.edu.ec" class="">Eléctrica, Electrónica y Telecomunicaciones</a>
            </li>
          </ul>
          <p><br></p>
          <h5 class="text-uppercase text-white">BASE LEGAL</h5>

          <ul class="list-unstyled mb-0">
            <li>
              <a href="https://usgn.espe.edu.ec" class="">Secretaria General</a>
            </li>
            <li>
              <a href="https://hcu.espe.edu.ec/" class="">Honorable Consejo Universitario</a>
            </li>
            <li>
              <a href="https://consejos.espe.edu.ec/" class="">Consejo Académico</a>
            </li>
          </ul>
        </div>
        </div>
        <!--Grid column-->

      </div>
      <!--Grid row-->
    </div>
  <!-- Grid container -->

  <!-- Copyright -->
  <div class="bottom-footer p-1 d-flex justify-content-center align-items-center text-white">
    <div class="content-container">
      <p class="m-0">
        {{ 'footer.copyright' | translate:{year: dateObj | date:'y'} }}
        <a class="text-white" src="https://repositorio.espe.edu.ec">repositorio.espe.edu.ec</a>
        <br /> Universidad de las Fuerzas  Armadas ESPE
        <!--<a class="text-white" </a>
           href="http://www.dspace.org/">{{ 'footer.link.dspace' | translate}}</a>
        {{ 'footer.copyright' | translate:{year: dateObj | date:'y'} }}
        <a class="text-white"
           href="https://www.lyrasis.org/">{{ 'footer.link.lyrasis' | translate}}</a>  -->
      </p>
      <ul class="footer-info list-unstyled d-flex justify-content-center mb-0">
        <li>
          <button class="btn btn-link text-white" type="button" (click)="showCookieSettings()">
            {{ 'footer.link.cookies' | translate}}
          </button>
        </li>
        <li *ngIf="showPrivacyPolicy">
          <a class="btn text-white"
             routerLink="info/privacy">{{ 'footer.link.privacy-policy' | translate}}</a>
        </li>
        <li *ngIf="showEndUserAgreement">
          <a class="btn text-white"
             routerLink="info/end-user-agreement">{{ 'footer.link.end-user-agreement' | translate}}</a>
        </li>
        <li *ngIf="showSendFeedback$ | async">
          <a class="btn text-white"
             routerLink="info/feedback">{{ 'footer.link.feedback' | translate}}</a>
        </li>
      </ul>
    </div>
    <div *ngIf="coarLdnEnabled$ | async" class="notify-enabled text-white">
      <a class="coar-notify-support-route" routerLink="info/coar-notify-support">
        <img class="n-coar" src="assets/images/n-coar.svg" [attr.alt]="'menu.header.image.logo' | translate" />
        {{ 'footer.link.coar-notify-support' | translate }}
      </a>
    </div>
  </div>
  <!-- Copyright -->
</footer>
